<template>
    <div>
        <b-modal 
            :id="modalId" 
            ref="modal"
            size="lg" 
            scrollable
            hide-footer
            body-class="p-0"
            content-class="biblioteca-modal"
        >
            <template #modal-header="{ close }">
                <div class="biblioteca-header w-100">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <div>
                            <h5 class="mb-0">Biblioteca de modelos</h5>
                            <small class="text-muted">Explore modelos para otimizar seu trabalho</small>
                        </div>
                        <button type="button" class="close" @click="close()">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                    
                    <!-- Campo de busca -->
                    <div class="search-wrapper">
                        <i class="fa fa-search search-icon"></i>
                        <input 
                            v-model="termoBusca" 
                            type="text" 
                            class="form-control search-input" 
                            placeholder="Buscar modelos por nome ou descrição..."
                        >
                    </div>
                </div>
            </template>
            
            <div class="biblioteca-content">
                <ListaPrompts
                    ref="listaPrompts"
                    :termo-busca-externo="termoBusca"
                    @usar-prompt="onUsarPrompt"
                    @editar-prompt="editarPrompt"
                />
            </div>
        </b-modal>
        
        <!-- Modal de Edição (usa o mesmo componente de favoritos) -->
        <ModalPromptFavoritos 
            ref="modalEditar"
            modal-id="modal-editar-prompt-biblioteca"
            @salvar="onPromptSalvo"
        />
    </div>
</template>

<script>
import ListaPrompts from './ListaPrompts.vue'
import ModalPromptFavoritos from './ModalPromptFavoritos.vue'

export default {
    name: 'ModalBibliotecaPrompts',
    
    components: {
        ListaPrompts,
        ModalPromptFavoritos
    },
    
    props: {
        modalId: {
            type: String,
            default: 'modal-biblioteca-prompts'
        }
    },
    
    data() {
        return {
            termoBusca: ''
        }
    },
    
    methods: {
        abrir() {
            this.$bvModal.show(this.modalId)
            this.$nextTick(() => {
                if (this.$refs.listaPrompts) {
                    this.$refs.listaPrompts.recarregar()
                }
            })
        },
        
        fechar() {
            this.$bvModal.hide(this.modalId)
        },
        
        onUsarPrompt(comando) {
            this.$emit('usar-prompt', comando)
            this.fechar()
        },
        
        editarPrompt(prompt) {
            this.$refs.modalEditar.abrirEdicao(prompt)
        },
        
        async onPromptSalvo() {
            if (this.$refs.listaPrompts) {
                this.$refs.listaPrompts.recarregar()
            }
        }
    }
}
</script>

<style scoped>
.biblioteca-header {
    padding: 0;
}

.biblioteca-header h5 {
    font-weight: 600;
    color: #333;
}

.biblioteca-header .close {
    font-size: 1.2rem;
    color: #999;
    opacity: 1;
    background: none;
    border: none;
    padding: 8px;
    cursor: pointer;
}

.biblioteca-header .close:hover {
    color: #333;
}

/* Campo de busca */
.search-wrapper {
    position: relative;
    margin-top: 12px;
}

.search-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
}

.search-input {
    padding-left: 40px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    background: #f8f9fa;
    height: 42px;
}

.search-input:focus {
    background: #fff;
    border-color: rgb(36, 61, 75);
    box-shadow: 0 0 0 2px rgba(36, 61, 75, 0.1);
}

/* Conteúdo */
.biblioteca-content {
    padding: 0;
}

/* Modal customization */
:deep(.biblioteca-modal) {
    border-radius: 16px;
    overflow: hidden;
}

:deep(.biblioteca-modal .modal-header) {
    border-bottom: none;
    padding: 20px 20px 0;
}

:deep(.biblioteca-modal .modal-body) {
    padding: 0;
}
</style>
